/**
 * Normalizes notification-trigger API responses for the UI.
 *
 * Success (80): { success: true, uiMessage, data }
 * Validation (90): { success: false, uiMessage, fieldErrors }
 */
export const parseTriggerResponse = (payload = {}) => {
  const {
    response_code: responseCode,
    ui_message: uiMessage,
    data = {},
    error = {},
  } = payload;

  if (responseCode === 80) {
    return {
      success: true,
      uiMessage: uiMessage || "Notifications are registered or triggered.",
      data,
      fieldErrors: [],
    };
  }

  const fieldErrors = formatFieldErrors(error);

  return {
    success: false,
    uiMessage:
      uiMessage ||
      (fieldErrors.length
        ? fieldErrors.join(" ")
        : "Request failed due to invalid data."),
    data: {},
    fieldErrors,
  };
};

const formatFieldErrors = (error) => {
  if (!error || typeof error !== "object" || Array.isArray(error)) {
    return [];
  }

  return Object.keys(error).reduce((lines, field) => {
    const value = error[field];
    const messages = Array.isArray(value) ? value : [value];
    messages.filter(Boolean).forEach((message) => {
      lines.push(`${field}: ${message}`);
    });
    return lines;
  }, []);
};
